import { LANGS, useT } from "../i18n";

/**
 * Selector de idioma discreto (banderas) para la cabecera del widget de
 * mesas. Cambia el idioma al instante (contexto React, sin recarga).
 *
 * `variant`:
 * - "light" (por defecto): para cabeceras claras (fondo blanco/gris de
 *   `App.tsx`).
 * - "dark": para cabeceras con fondo de color sólido (`ReservationManage`
 *   usa una cabecera teal-600).
 */
export default function LanguageSwitcher({
  variant = "light",
}: {
  variant?: "light" | "dark";
}) {
  const { lang, setLang } = useT();

  return (
    <div
      className={`inline-flex items-center gap-0.5 rounded-full p-0.5 ${
        variant === "dark" ? "bg-white/15" : "bg-gray-100"
      }`}
      role="group"
      aria-label="Idioma / Language"
    >
      {LANGS.map((option) => {
        const isActive = option.code === lang;
        return (
          <button
            key={option.code}
            type="button"
            onClick={() => setLang(option.code)}
            title={option.label}
            aria-pressed={isActive}
            aria-label={option.label}
            className={`flex h-6 w-6 items-center justify-center rounded-full text-sm leading-none transition-all ${
              isActive
                ? variant === "dark"
                  ? "bg-white shadow-sm scale-110"
                  : "bg-white shadow-sm ring-1 ring-gray-200 scale-110"
                : "opacity-50 hover:opacity-90"
            }`}
          >
            <span aria-hidden="true">{option.flag}</span>
          </button>
        );
      })}
    </div>
  );
}
